/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RecordingCapHitsBucket interface.
 */
export function instanceOfRecordingCapHitsBucket(value) {
    if (!('distinctUsers' in value) || value['distinctUsers'] === undefined)
        return false;
    if (!('totalEvents' in value) || value['totalEvents'] === undefined)
        return false;
    return true;
}
export function RecordingCapHitsBucketFromJSON(json) {
    return RecordingCapHitsBucketFromJSONTyped(json, false);
}
export function RecordingCapHitsBucketFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'distinctUsers': json['distinctUsers'],
        'totalEvents': json['totalEvents'],
    };
}
export function RecordingCapHitsBucketToJSON(json) {
    return RecordingCapHitsBucketToJSONTyped(json, false);
}
export function RecordingCapHitsBucketToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'distinctUsers': value['distinctUsers'],
        'totalEvents': value['totalEvents'],
    };
}
